import { History } from 'history';
import { action, observable } from 'mobx';
import { API } from '../../api/api';
import { Passenger } from '../../models/passenger';
import { AppStore } from '../../stores/app-store';
import { unreachable } from '../../utils/compose';

// tslint:disable:readonly-keyword

export class PassengerDetailStore {
  @observable public redeemState = RedeemState.IDLE;

  constructor(
    private readonly history: History,
    private readonly appStore: AppStore,
    private readonly api: API,
    private readonly passenger: Passenger,
  ) {}

  @action
  public async handleClickRedeemVoucher() {
    if (!this.appStore.pnr || !this.appStore.lastName) throw new Error('bug');

    this.redeemState = RedeemState.LOADING;
    const response = await this.api.redeemVoucher(
      this.appStore.pnr,
      this.appStore.lastName,
      this.passenger,
    );
    switch (response.status) {
      case 'ok':
        this.handleRedeemSuccess(response.passenger);
        break;

      case 'network-error':
      case 'unexpected-error':
        this.handleReedemError();
        break;

      default:
        unreachable(response);
        break;
    }
  }

  @action
  public handleRedeemSuccess(passenger: Passenger) {
    this.redeemState = RedeemState.IDLE;
    this.appStore.updatePassenger(passenger);
    this.history.push(`/redeem/${passenger.id}`);
  }

  @action
  public handleReedemError() {
    this.redeemState = RedeemState.ERROR;
  }
}

export const enum RedeemState {
  IDLE,
  LOADING,
  ERROR,
}



// WEBPACK FOOTER //
// ../node_modules/source-map-loader!./src/components/segment/passenger-detail-store.ts